import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'productName', standalone: true })
export class ProductNamePipe implements PipeTransform {
    transform(type: string): string {
        let productName;
        switch (type) {
            case 'HO3':
                productName = 'Homeowners';
                break;
            case 'HO4':
                productName = 'Renters';
                break;
            case 'HO6':
                productName = 'Condo';
                break;
            case 'DP1':
                productName = 'Basic Dwelling';
                break;
            case 'DP3':
                productName = 'Special Dwelling';
                break;
            case 'Street':
                productName = 'Motorcycle Street';
                break;
            case 'OffRoad':
                productName = 'Off-road';
                break;
            case 'MCST':
                productName = 'Motorcycle';
                break;
            case 'MCOR':
                productName = 'Motorcycle Off-road';
                break;
            case 'PB':
                productName = 'Boat';
                break;
            case 'PleasureBoat':
                productName = 'Boat';
                break;
            case 'PWC':
                productName = 'Watercraft';
                break;
            case 'MH':
                productName = 'Manufactured Home';
                break;
            case 'CPL':
                productName = 'Personal Liability';
                break;
            case 'PUP':
                productName = 'Personal Umbrella';
                break;
            case 'EQ':
                productName = 'Earthquake';
                break;
            default:
                productName = 'Homeowners';
                break;
        }
        return productName;
    }
}
